<mat-dialog-content>
    <div class="dialog-header">
        <div class="close-button" (click)="closeModal()">
            <i class="material-icons icon">cancel</i>
        </div>
    </div>

    <form [formGroup]="overtimeForm">
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group" *ngIf="data.rejectReasonId !== null && data.rejectReasonId !== undefined">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Red Nedeni" [value]="data.rejectDescription" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Personel Ad Soyadı" style="width: 250px;" [value]="data.name + ' ' + data.surname" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Departman" style="width: 250px;" [value]="data.departmentName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Fazla Mesai Türü" [value]="data.overtimeTypeName" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-4">
                <mat-checkbox [checked]="data.isRestDay === 1" disabled>
                    Hafta tatili mi ?
                </mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <input matInput placeholder="Mesai Tarihi" [value]="data.overtimeDate" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <input matInput placeholder="Başlangıç Saati" [value]="data.startTime" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <mat-form-field class="w-100">
                        <input matInput placeholder="Bitiş Saati" [value]="data.endTime" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Şube" [value]="data.branchName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Proje" [value]="data.projectName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <div class="form-group" *ngIf="data.projectName.includes('KİRACI')">
                    <mat-form-field class="overtime-form-field">
                        <input matInput placeholder="Kiracı" [value]="data.tenantName" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <input matInput placeholder="Mesai Süresi" [value]="data.overtimeHours + ' saat'" readonly>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <mat-form-field class="lookup-form-field" style="width: 100%;">
                        <textarea style="height: 100px;resize: none;" matInput placeholder="Açıklama" readonly>{{data.description}}</textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="form-group">
            <div *ngIf="portalDocumentList && portalDocumentList.length > 0">
                <div *ngFor="let document of portalDocumentList" class="filename-wrapper">
                    <a href="{{fileUploadRootPath}}/{{document.filePath}}" target="_blank" style="width: 100px;max-width: 100px;">
                        {{ document.fileName || 'Dosyayı Görüntüle' }}
                    </a>
                </div>
            </div>
            <div *ngIf="!portalDocumentList || portalDocumentList.length === 0">
                Dosya bulunamadı.
            </div>
        </div>
    </form>
</mat-dialog-content>